export default __webpack_public_path__ + "0f97ffc4825b009b03e67f1c714dc2a8.png";